import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { OrderStatusModel } from '@libs/shared/models';
import { OrderStatusRepositoryService } from './order-status-repository.service';

@Injectable({ providedIn: 'root' })
export class OrderStatusService {
  private readonly orderStatusRepositoryService: OrderStatusRepositoryService = inject(OrderStatusRepositoryService);

  public getOrderStatus(orderId: string): Observable<OrderStatusModel> {
    return this.orderStatusRepositoryService.getOrderStatus(orderId);
  }
}
